import PropTypes from "prop-types";
import React, { useState } from "react";
import { connect } from "react-redux";
import {
  clearSuccessState,
  sendOutwardInteractionValues,
} from "../../redux/Actions/NipActions";
import FundTransfer from "./FundsTransfer";
import NameEnquiry from "./NameEnquiry";
import StatusQuery from "./StatusQuery";

const OutwardInteraction = (props) => {
  const {
    isGettingNE,
    getNESuccess,
    nameEnquiryValues,
    isSendingNE,
    sendNESuccess,
    nameEnquiryData,
    isSendingFT,
    sendFTSuccess,
    fundTransferData,
    isSendingSQ,
    sendSQSuccess,
    statusQueryData,
    sendValues,
    clearSuccessState,
  } = props;

  const [state, setstate] = useState({
    active1: true,
    active2: false,
    active3: false,
  });

  const setNameEnquiry = () => {
    setstate({
      ...state,
      active1: true,
      active2: false,
      active3: false,
    });
  };

  const setFundTransfer = () => {
    setstate({
      ...state,
      active1: false,
      active2: true,
      active3: false,
    });
  };

  const setStatusQuery = () => {
    setstate({
      ...state,
      active1: false,
      active2: false,
      active3: true,
    });
  };

  return (
    <div className="nip-home-interaction">
      {state.active1 ? (
        <NameEnquiry
          goToFundTransfer={setFundTransfer}
          isGetting={isGettingNE}
          getSuccess={getNESuccess}
          nameEnquiryValues={nameEnquiryValues}
          isSending={isSendingNE}
          sendSuccess={sendNESuccess}
          sendNameEnquiryValues={sendValues}
          nameEnquiryData={nameEnquiryData}
          clearSuccessState={clearSuccessState}
        />
      ) : state.active2 ? (
        <FundTransfer
          goToStatusQuery={setStatusQuery}
          goToNameEquiry={setNameEnquiry}
          isSending={isSendingFT}
          sendSuccess={sendFTSuccess}
          nameEnquiryData={nameEnquiryData}
          sendFundTransferValues={sendValues}
          fundTransferData={fundTransferData}
          clearSuccessState={clearSuccessState}
        />
      ) : (
        <StatusQuery
          goToNameEnquiry={setNameEnquiry}
          goToFundTransfer={setFundTransfer}
          fundTransferData={fundTransferData}
          isSending={isSendingSQ}
          sendSuccess={sendSQSuccess}
          sendStatusQueryValues={sendValues}
          statusQueryData={statusQueryData}
          clearSuccessState={clearSuccessState}
        />
      )}
    </div>
  );
};

OutwardInteraction.propTypes = {
  clearSuccessState: PropTypes.func,
  fundTransferData: PropTypes.any,
  getNESuccess: PropTypes.bool,
  isGettingNE: PropTypes.bool,
  isSendingFT: PropTypes.bool,
  isSendingNE: PropTypes.bool,
  isSendingSQ: PropTypes.bool,
  nameEnquiryData: PropTypes.any,
  nameEnquiryValues: PropTypes.any,
  sendFTSuccess: PropTypes.bool,
  sendNESuccess: PropTypes.bool,
  sendSQSuccess: PropTypes.bool,
  sendValues: PropTypes.func,
  statusQueryData: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    isGettingNE: state.nip.isGettingNameEnquiryValues,
    getNESuccess: state.nip.getNameEnquiryValuesSuccess,
    nameEnquiryValues: state.nip.nameEnquiryValues,
    isSendingNE: state.nip.isSendingNameEnquiryValues,
    sendNESuccess: state.nip.sendNameEnquiryValuesSuccess,
    nameEnquiryData: state.nip.sendNameEnquiry,
    isSendingFT: state.nip.isSendingFundTransferValues,
    sendFTSuccess: state.nip.sendFundTransferValuesSuccess,
    fundTransferData: state.nip.sendFundTransfer,
    isSendingSQ: state.nip.isSendingStatusQueryValues,
    sendSQSuccess: state.nip.sendStatusQueryValuesSuccess,
    statusQueryData: state.nip.sendStatusQuery,
  };
};

const mapDispatchToProps = (dispatch) => ({
  clearSuccessState: () => dispatch(clearSuccessState()),
  sendValues: (name, payload) =>
    dispatch(sendOutwardInteractionValues(name, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OutwardInteraction);
